import { not, contains } from 'ramda'
import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import rootReducer from '../reducers/index'
import rootSaga from '../sagas/index'

// the logger master switch
const USE_LOGGING = false

// silence these saga-based messages
const SAGA_LOGGING_BLACKLIST = ['EFFECT_TRIGGERED', 'EFFECT_RESOLVED', 'EFFECT_REJECTED']

// create the logger
const logger = createLogger({
  predicate: (getState, { type }) => USE_LOGGING && not(contains(type, SAGA_LOGGING_BLACKLIST))
})

// a function which can create our store and auto-persist the data
export default () => {
  // create the saga middleware
  const sagaMiddleware = createSagaMiddleware();

  // add our normal middleware to the list
  const middleware = applyMiddleware(logger, sagaMiddleware);

  // create the store with a root reducer & a composed list of enhancers
  const store = createStore(rootReducer, middleware);

  // kick off the root saga
  sagaMiddleware.run(rootSaga);

  return store
}
